import { CustomerOverviewSchema } from '@vy/api-definition';
import type { oz } from '@vy/utils';

export const PlanAssignmentCustomerDataSchema = CustomerOverviewSchema.pick({
  id: true,
  name: true,
  contractsCount: true,
});

export type PlanAssignmentCustomerData = oz.infer<typeof PlanAssignmentCustomerDataSchema>;
